import { PredecessorShipment } from "../../../models/home/CarrierAssign.model";

export const getPredecessorShipmentPayload = (
    { loadDetails, driver }: { loadDetails: any, driver: any }) => {
    const predecessorModal: PredecessorShipment = new PredecessorShipment();

    predecessorModal.shipmentId = loadDetails.shipmentId;
    predecessorModal.driverId = (driver?.userPrincipalName || driver?.upn)|| driver.mobileNumber;
    predecessorModal.assignSource = "";

    return predecessorModal.getPredecessorRequestPayload()
}